import React, { Component } from "react";
import axios from "axios";
import ClienteCard from "./ClienteCard";

import { Input, Result, message} from "antd";
import "../sass/ClienteList.scss";
import ClienteDetail from "./ClienteDetail";
import { Modal, Button } from "antd";
import NewClient from "./NewClient";


import { Spin } from "antd";

const { Search } = Input;

export default class ClienteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clienti: [],
      notFound: false,
      clienteSelected: null,
      visible: false,
      loading: false,
      creatingUser: false,
      loadingClienti: false,
    };

    this.onSearch = this.onSearch.bind(this);
    this.selectCliente = this.selectCliente.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.addingNewUser = this.addingNewUser.bind(this);
    this.addingNewUserOk = this.addingNewUserOk.bind(this);
    this.addingNewUserCancel = this.addingNewUserCancel.bind(this);

    this.updateCliente = this.updateCliente.bind(this);

    this.fetchClienti = this.fetchClienti.bind(this);
  }

  onSearch(value) {
    if (value === "") {
      this.fetchClienti();
    }

    if (value !== "") {
      this.fetchOneCliente(value);
    }
  }

  componentDidMount() {
    // fetch the clienti from the rest
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    this.fetchClienti();

    console.log(this.props)
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  addingNewUser = () => {
    this.setState({ creatingUser: true }, () => {
      console.log(this.state.creatingUser);
    });
  };


  handleCancel = (e) => {
    this.setState({
      visible: false,
      clienteSelected: null
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
      clienteSelected: null
    });
  }

  addingNewUserOk(e) {
    this.setState({ creatingUser: false });
  }

  addingNewUserCancel(e) {
    this.setState({ creatingUser: false });
  }

  fetchClienti() {
    console.log('fetching clients')
    this.setState({ loadingClienti: true });

    axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/api/clienti/negozio?from=0&size=100`
      )
      .then((response) => {
        // handle success
        this.setState({
          notFound: false,
          clienti: response.data.hits,
          loadingClienti: false,
        });
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed

        // console.log(this.state.clienti);
      });
  }

  async fetchOneCliente(id) {
    await axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/clienti/GetById?id=${id}`)
      .then((response) => {

        if (response.status === 200) {
          // handle success
          this.setState({ notFound: false, clienti: response.data.hits });
        } else {
          this.setState({ notFound: true, clienti: [] });
        }

      })
      .catch((error) => {
        this.setState({ notFound: true, clienti: [] });
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed

        console.log(this.state.clienti);
      });
  }

  RenderNotFound() {
    if (this.state.notFound) {
      return (
        <Result
          status="404"
          title="Cliente Non Trovato"
          subTitle="Il Cliente non e' stato trovato."
        />
      );
    } else {
      <div></div>;
    }
  }

  renderList() {
    if (this.state.loadingClienti && !this.state.notFound) {
      return <Spin />;
    } else {

      return this.state.clienti.map((cliente) => (
        <div key={cliente._source.cardId}>

          <ClienteCard
            key={cliente._source.cardId}
            cliente={cliente}
            selectCliente={this.selectCliente}
            showModal={this.showModal}
          />


        </div>
      ));
    }
  }

  selectCliente(clienteSelected) {
    this.setState({ clienteSelected: clienteSelected }, () => this.showModal());
  }

  updateCliente(client) {

    this.setState({ clienteSelected: client }, () => {
      axios
        .put(
          `${process.env.REACT_APP_SERVER_URL}/api/clienti?id=${this.state.clienteSelected._source.cardId}`,
          this.state.clienteSelected._source
        )
        .then(
          (response) => {

            if (response.status === 200) {
              message.success("cliente aggiornato con successo");
              this.setState({ visible: false });
            }
          },
          (error) => {
            message.error("errore nell'aggiornamento del cliente");
          }
        );
    })

  }


  renderClienteDetail() {

    if (this.state.clienteSelected) {
      return (<ClienteDetail
        key={this.state.clienteSelected._source.cardId}
        cliente={this.state.clienteSelected}
        clientAction={this.updateCliente}
        role={this.props.role}
        negozio={this.props.negozio}
      />
      )
    }
  }

  render() {
    return (
      <div>
        <div id="search_bar">
          <Search
            placeholder="Cerca un cliente"
            allowClear
            enterButton="Cerca"
            size="large"
            onSearch={this.onSearch}
          />
        </div>


        <div id="clienteManager">

          <div id="clienteDetail">
            <NewClient negozio={this.props.negozio} fetchClienti={this.fetchClienti} role={this.props.role} />
          </div>


          <div id="ClienteList">{this.renderList()}</div>{" "}
          {this.RenderNotFound()}


          <Modal
            width={'80vw'}
            title="Profilo Cliente"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={[
              <Button key="1" onClick={this.handleCancel}>
                Torna indietro
              </Button>
              
            ]}
          >

            {this.renderClienteDetail()}
          </Modal>


        </div>
      </div>
    );
  }
}
